<template>
  <div class="hose-display" :class="device">
    <pdf-downloader></pdf-downloader>

    <div class="price">
      <div class="price-container">
        <span class="total-price" v-text="'€ ' + formatPrice(prices.price)"></span>
        <template v-if="isMagento">
            <span class="btw-price">2+ € {{ formatPrice(prices.priceTwoMagento) }}</span>
            <span class="btw-price">5+ € {{ formatPrice(prices.priceFiveMagento) }}</span>
            <span class="btw-price">10+ € {{ formatPrice(prices.priceTenMagento) }}</span>
        </template>
        <template v-else>
            <span class="btw-price">2+ € {{ formatPrice(prices.pressCostTwo) }}</span>
            <span class="btw-price">5+ € {{ formatPrice(prices.pressCostFive) }}</span>
            <span class="btw-price">10+ € {{ formatPrice(prices.pressCostTen) }}</span>
        </template>
        <span class="btw-price">{{ $t('cart.exclVat') }}</span>
      </div>
    </div>

    <div class="cart-container">
      <div class="cart-button" @click.stop="addToCart()" :class="{disabled: !canAdd}">
        <img class="icon" src="../../assets/cart-icon.png">
        <span>{{ $t('cart.addToCart') }}</span>
      </div>
      <span class="delivery-message">{{ $t('cart.orderToday') }}</span>
    </div>

    <input-field
        :class="{rotation: showRotation}"
        :label="this.$t('hose.length')"
        v-model="hoseLength"
        type="number"
        suffix="mm"
        :info="false"
        :error="this.errors.includes('length')"
    ></input-field>

    <popup-trigger
        :id="1"
        :label="this.$t('hose.type')"
        :value="Object.keys(build.selectedHose).length !== 0 ? this.translate(build.selectedHose.title) : 'Selecteer een slang'"
        :tool-link="true"
        :link-label="this.$t('general.helpTool')"
        @change="popupType"
        popup="null"
    ></popup-trigger>

    <InfoCheckbox
        :class="{'inline': !showRotation }"
        class="hose-label"
        :label="this.$t('hose.hoseLabel')"
        :value="hoseLabel"
        @change="setHoseLabel"
        tooltip-key="tooltip_hose_label"
    />

    <ToggleInput
        :class="{'magento': isMagento, 'inline': !showRotation }"
        class="test-certificate"
        :label="this.$t('hose.testCertificate')"
        :value="testCertificateBarAmount"
        @toggle="setTestCertificate"
        @change="setTestCertificateBarAmount"
        tooltip-key="tooltip_hose_test_certificate"
    />

    <popup-trigger
        v-if="showRotation"
        :class="{rotation: showRotation}"
        :id="4"
        :label="this.$t('hose.rotation')"
        :value="build.rotation ? translate(build.rotation.name) + ' +' + formatPrice(build.rotation.price / 100) : 'Selecteer een verdraaiing'"
        popup="rotation"
        @change="popupType"
    ></popup-trigger>

    <canvas-image
        :couplingA="build.couplingA"
        :couplingB="build.couplingB"
        :hose="build.selectedHose"
        :rotation="showRotation === 1"
    ></canvas-image>

    <popup-trigger
        :id="2"
        :label="this.$t('hose.couplingA')"
        :value="build.couplingA ? translate(build.couplingA.title) : 'Selecteer een koppeling'"
        popup="couplingA"
        @change="popupType"
        :error="this.errors.includes('couplingA')"
    ></popup-trigger>

    <popup-trigger
        :id="3"
        :label="this.$t('hose.couplingB')"
        :value="build.couplingB ? translate(build.couplingB.title) : 'Selecteer een koppeling'"
        popup="couplingB"
        @change="popupType"
        :error="this.errors.includes('couplingB')"
    ></popup-trigger>
  </div>
</template>

<script>
import PdfDownloader from "@/components/hose/components/PdfDownloader";
import InputField from "@/components/hose/components/InputField";
import {mapGetters} from "vuex";
import PopupTrigger from "@/components/hose/components/PopupTrigger";
import CanvasImage from "@/components/hose/components/CanvasImage";
import getBuildMixin from "@/mixins/getBuildMixin";
import addToCartMixin from "@/mixins/addToCartMixin";
import ToggleInput from "@/components/input/ToggleInput.vue";
import InfoCheckbox from "@/components/input/InfoCheckbox.vue";

export default {
  name: "HoseDisplay",

  mixins: [getBuildMixin, addToCartMixin],

  components: {
    InfoCheckbox,
    CanvasImage,
    PopupTrigger,
    InputField,
    PdfDownloader,
    ToggleInput
  },

  data() {
    return {
      errors: [],
      pressPriceHover: false,
    }
  },

  computed: {
    ...mapGetters({
      preferences: 'build/hoses/getHosePreferences',
      build: 'build/hoses/getHoseBuild',
      extras: 'build/hoses/getHoseExtras',
      prices: 'build/hoses/getHosePrices',
      device: 'getDevice',
      isMagento: 'preference/isMagento',
    }),
    hoseLength: {
      get() {
        return this.preferences.length;
      },
      set(val) {
        this.$store.commit('build/hoses/setLength', +val);
      },
    },
    testCertificateBarAmount() {
      return this.extras.test_certificate_bar_amount;
    },
    hoseLabel() {
      return this.extras.hoseLabel;
    },
    showRotation() {
      return this.build.couplingA && this.build.couplingA.rotatable && this.build.couplingB && this.build.couplingB.rotatable;
    },
    btwPrice() {
      let price = this.prices.price;
      return price * 1.21;
    },
    canAdd() {
      this.errors = [];
      const build = this.$store.getters['build/hoses/getBuildObject'];
      if (!build.coupling_a_id) {
        this.errors.push('couplingA');
        return false;
      }
      if (!build.coupling_b_id) {
        this.errors.push('couplingB');
        return false;
      }
      if (build.length < 100) {
        this.errors.push('length');
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    setTestCertificateBarAmount(value) {
      this.$store.commit('build/hoses/setTestCertificateBarAmount', value);
    },
    setTestCertificate(value) {
        this.$store.commit('build/hoses/setTestCertificate', value);
    },
    setHoseLabel(value) {
      this.$store.commit('build/hoses/setHoseLabel', value);
    },
    popupType(val) {
      this.$store.dispatch('build/hoses/setPopup', val);
    },
    addToCart() {
      if(this.canAdd) {
        if (this.isMagento) {
          this.$emit('openModal');
          this.$store.dispatch('cart/addHoseMagentoOrder', 'hose')
              .then((order) => {
                this.$store.commit('cart/setCurrentOrder', order);
              })
              .catch((error) => {
                this.$store.commit('cart/setCurrentOrder', { error: error });
              });
        } else {
          this.$store.dispatch('build/hoses/addOrder');
        }
      }
    },
  }
}
</script>

<style lang="scss">
.hose-display {
  grid-row-start: 1;
  grid-row-end: 3;
  grid-column-start: 2;
  grid-column-end: 3;
  background-color: #FAFAFA;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);
  padding: 16px 22px;
  display: grid;
  grid-template-columns: repeat(13, auto);
  grid-template-rows: repeat(7, auto);
  position: relative;

  .price {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    grid-column: 10/ span 3;
    grid-row: 1/3;
    min-width: 82px;
    margin-left: 20px;
    position: relative;

    .price-container {
      display: flex;
      flex-direction: column;

      img {
        margin-left: 5px;
      }
    }

    .total-price {
      font-family: neue-haas-grotesk-display, sans-serif;
      font-size: 24px;
      color: #3DB0C7;
    }

    .btw-price {
      font-family: neue-haas-grotesk-text, sans-serif;
      font-size: 11px;
    }

    .press-costs {
      border: 1px #3DB0C7 solid;
      border-radius: 4px;
      padding: 5px;
      color: #3DB0C7;
      font-weight: bold;
      text-align: right;
      position: absolute;
      background-color: white;
      width: 100px;
      left: 105%;
      z-index: 9;

      span {
        display: block;
      }

      .btw {
        font-size: 12px;
      }
    }
  }

  .cart-container {
    grid-column: 13/16;
    grid-row: 1/4;
    //max-width: 238px;
    text-align: center;
    margin-left: auto;

    .cart-button {
      background-color: #71BC03;
      max-height: 46px;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: white;
      padding: 14px 10px 14px 10px;
      position: relative;
      text-transform: uppercase;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-size: 14px;
      transition: all ease 0.3s;
      cursor: pointer;
      user-select: none;

      &.disabled {
        background-color: #AFAFAF;
        cursor: not-allowed;

        &:hover {
          background-color: darken(#AFAFAF, 10%);
        }
      }

      span {
        display: block;
        margin-left: 30px;
      }

      &:hover {
        background-color: darken(#71BC03, 10%);
      }

      .icon {
        position: absolute;
        left: 8%;
      }
    }

    .delivery-message {
      font-size: 12px;
      font-family: neue-haas-grotesk-display, sans-serif;
      color: #71BC03;
    }
  }

  .input-field {
    grid-column: 6/9;
    grid-row: 2/4;
    z-index: 1;
    margin-left: auto;
    max-width: 135px;

    &.rotation {
      grid-column: 7/9;
    }

    @media only screen and (max-width: 1024px) {
      grid-column: 5/9;
      margin: 0;
    }
  }

  .hose-label {
    grid-column: 3/8;
    grid-row: 4;
    z-index: 1;
  }

  .test-certificate {
    grid-column: 9/10;
    grid-row: 4;
    z-index: 1;

    &.magento {
      grid-column: 7/9;
    }
  }

  .trigger-1 {
    grid-column: 9/10;
    grid-row: 2/4;
    z-index: 1;
  }

  .trigger-2 {
    grid-column: 1/4;
    grid-row: 7/8;
  }

  .trigger-3 {
    grid-column: 13/15;
    grid-row: 7/8;
  }

  .trigger-4 {
    grid-column: 11/12;
    grid-row: 4/5;

    &.rotation {
      grid-row: 4/5;
    }
  }

  .measurement-line {
    position: absolute;
    border-top: 1px solid #3DB0C7;
    z-index: 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    grid-column: 2/14;
    grid-row: 3/4;
    top: 6px;

    &.rotation {
      grid-column: 2/14;
    }

    .coupling-a {
      cursor: pointer;
      position: relative;
      top: 6px;
      left: -6px;

      &:before {
        position: relative;
        content: '';
        border-left: 1px solid #3DB0C7;
        top: -18px;
        right: -6px;
      }
    }

    .coupling-b {
      cursor: pointer;
      position: relative;
      top: 6px;
      right: -6px;

      &:after {
        position: relative;
        content: '';
        border-left: 1px solid #3DB0C7;
        top: -18px;
        left: -6px;
      }
    }
  }

  &.desktop,
  &.tablet {
    .hose-label.inline {
      margin-top: 11px;
    }

    .test-certificate.inline {
      grid-column: 9/13;
      display: flex;
      align-items: flex-start;

      .custom-checkbox {
        margin-top: 11px;
        margin-right: 6px;
      }
    }
  }

  &.mobile {
    max-width: 100%;
    overflow-x: hidden;
    grid-row: 1/2;
    grid-column: 1/2;
    margin: 0 auto;
    max-height: 600px;
    grid-template-columns: repeat(10, 1fr);
    grid-template-rows: repeat(4, auto);
    grid-gap: 10px;
    padding: 15px;

    .download-pdf {
      display: none;
    }

    .price {
      grid-column: 1 / 4;
      grid-row: 6 / 7;
      align-items: flex-start;

      .total-price {
        font-size: 20px;
        white-space: nowrap;
      }

      .btw-price {
        white-space: nowrap;
      }


      @media only screen and (max-width: 390px) {
        grid-row: 6 / 7;
      }
    }

    .cart-container {
      grid-column: 4 / 11;
      grid-row: 6 / 7;

      .cart-button {
        font-size: 12px;
        padding: 14px 20px 14px 32px;
      }

      @media only screen and (max-width: 390px) {
        grid-column: 1 / 11;
        grid-row: 7 / 8;
        display: flex;
        margin: 0;
        max-width: 100%;
        flex-direction: column;
        justify-content: center;

        .cart-button {
          margin: 0 auto;
          max-width: 240px;
        }
      }
    }

    .input-field {
      grid-column: 1 / 6;
      grid-row: 1 / 2;
    }

    .test-certificate {
      grid-column: 1 / 6;
      grid-row: 4 / 5;
      z-index: 1;


      @media only screen and (max-width: 390px) {
        grid-column: 1 / 11;
      }
    }

    .hose-label {
      grid-column: 6/11;
      grid-row: 4 / 5;
      z-index: 1;


      @media only screen and (max-width: 390px) {
        grid-column: 1 / 11;
        grid-row: 5 / 6;
      }
    }

    .trigger-1 {
      display: none;
    }

    .trigger-2 {
      grid-column: 1 / 6;
      grid-row: 3 / 4;
      margin-left: 0;
    }

    .trigger-3 {
      grid-column: 6 / 11;
      grid-row: 3 / 4;
    }

    .trigger-4 {
      grid-column: 6 / 11;
      grid-row: 1 / 2;
    }

    .measurement-line {
      display: none;
    }
  }

  &.tablet {

  }
}
</style>
